export enum BankIntegration {
    FINAPI = 'finApi',
}

export enum BankWorkflowType {
    SELECT_BANK = 'selectBank',
    CONNECT_BANK = 'connectBank',
}
